/**
 * Generated by the protoc-gen-ts.  DO NOT EDIT!
 * compiler version: 3.19.4
 * source: int/http/hall/webview.proto
 * git: https://github.com/thesayyn/protoc-gen-ts */

/*
    此处请修改为Creator NpmExport路径
    请注意路径的层级
 */
import * as pb_1 from 'google-protobuf'
export namespace Webview {
  /**
      /**
      APP ID: 10026


       消息ID
       **/
  export enum MessageID {
    PING = 0,

    /**
          获取活动信息；
           **/
    ACT_INFO = 1,

    /**
          获取活动详情
           **/
    ACT_DETAIL = 2,

    /**
          提交问卷
           **/
    SUBMIT_SURVEY = 3,
  }
  export enum AwardType {
    /**
          金币
           **/
    Gold = 0,

    /**
          礼金
           **/
    Bonus = 1,
  }

  /**
      / 获取活动信息
       /api/v1/proxy/10026/1/
       **/
  export class ActInfoReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            timestamp?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('timestamp' in data && data.timestamp != undefined) {
          this.timestamp = data.timestamp
        }
      }
    }
    get timestamp() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }
    set timestamp(value: number) {
      pb_1.Message.setField(this, 1, value)
    }
    static fromObject(data: { timestamp?: number }): ActInfoReq {
      const message = new ActInfoReq({})
      if (data.timestamp != null) {
        message.timestamp = data.timestamp
      }
      return message
    }
    toObject() {
      const data: {
        timestamp?: number
      } = {}
      if (this.timestamp != null) {
        data.timestamp = this.timestamp
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.timestamp != 0) writer.writeInt64(1, this.timestamp)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActInfoReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ActInfoReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.timestamp = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ActInfoReq {
      return ActInfoReq.deserialize(bytes)
    }
  }
  export class ActInfoResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            conf_id?: string
            url?: string
            expired_at?: number
            desc?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('conf_id' in data && data.conf_id != undefined) {
          this.conf_id = data.conf_id
        }
        if ('url' in data && data.url != undefined) {
          this.url = data.url
        }
        if ('expired_at' in data && data.expired_at != undefined) {
          this.expired_at = data.expired_at
        }
        if ('desc' in data && data.desc != undefined) {
          this.desc = data.desc
        }
      }
    }

    /**
          问卷配置ID
           **/
    get conf_id() {
      return pb_1.Message.getFieldWithDefault(this, 1, '') as string
    }

    /**
          问卷配置ID
           **/
    set conf_id(value: string) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          问卷地址
           **/
    get url() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          问卷地址
           **/
    set url(value: string) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          过期时间
           **/
    get expired_at() {
      return pb_1.Message.getFieldWithDefault(this, 3, 0) as number
    }

    /**
          过期时间
           **/
    set expired_at(value: number) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          帮助描述
           **/
    get desc() {
      return pb_1.Message.getFieldWithDefault(this, 4, '') as string
    }

    /**
          帮助描述
           **/
    set desc(value: string) {
      pb_1.Message.setField(this, 4, value)
    }
    static fromObject(data: {
      conf_id?: string
      url?: string
      expired_at?: number
      desc?: string
    }): ActInfoResp {
      const message = new ActInfoResp({})
      if (data.conf_id != null) {
        message.conf_id = data.conf_id
      }
      if (data.url != null) {
        message.url = data.url
      }
      if (data.expired_at != null) {
        message.expired_at = data.expired_at
      }
      if (data.desc != null) {
        message.desc = data.desc
      }
      return message
    }
    toObject() {
      const data: {
        conf_id?: string
        url?: string
        expired_at?: number
        desc?: string
      } = {}
      if (this.conf_id != null) {
        data.conf_id = this.conf_id
      }
      if (this.url != null) {
        data.url = this.url
      }
      if (this.expired_at != null) {
        data.expired_at = this.expired_at
      }
      if (this.desc != null) {
        data.desc = this.desc
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.conf_id.length) writer.writeString(1, this.conf_id)
      if (this.url.length) writer.writeString(2, this.url)
      if (this.expired_at != 0) writer.writeInt64(3, this.expired_at)
      if (this.desc.length) writer.writeString(4, this.desc)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActInfoResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ActInfoResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.conf_id = reader.readString()
            break
          case 2:
            message.url = reader.readString()
            break
          case 3:
            message.expired_at = reader.readInt64()
            break
          case 4:
            message.desc = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ActInfoResp {
      return ActInfoResp.deserialize(bytes)
    }
  }

  /**
      / 获取活动
       /api/v1/proxy/10026/2/
       **/
  export class ActDetailReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            timestamp?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('timestamp' in data && data.timestamp != undefined) {
          this.timestamp = data.timestamp
        }
      }
    }
    get timestamp() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }
    set timestamp(value: number) {
      pb_1.Message.setField(this, 1, value)
    }
    static fromObject(data: { timestamp?: number }): ActDetailReq {
      const message = new ActDetailReq({})
      if (data.timestamp != null) {
        message.timestamp = data.timestamp
      }
      return message
    }
    toObject() {
      const data: {
        timestamp?: number
      } = {}
      if (this.timestamp != null) {
        data.timestamp = this.timestamp
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.timestamp != 0) writer.writeInt64(1, this.timestamp)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActDetailReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ActDetailReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.timestamp = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ActDetailReq {
      return ActDetailReq.deserialize(bytes)
    }
  }
  export class ActDetailResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            conf_id?: string
            question_content?: string
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('conf_id' in data && data.conf_id != undefined) {
          this.conf_id = data.conf_id
        }
        if ('question_content' in data && data.question_content != undefined) {
          this.question_content = data.question_content
        }
      }
    }

    /**
          问卷配置ID
           **/
    get conf_id() {
      return pb_1.Message.getFieldWithDefault(this, 1, '') as string
    }

    /**
          问卷配置ID
           **/
    set conf_id(value: string) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          问卷类容
           **/
    get question_content() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          问卷类容
           **/
    set question_content(value: string) {
      pb_1.Message.setField(this, 2, value)
    }
    static fromObject(data: { conf_id?: string; question_content?: string }): ActDetailResp {
      const message = new ActDetailResp({})
      if (data.conf_id != null) {
        message.conf_id = data.conf_id
      }
      if (data.question_content != null) {
        message.question_content = data.question_content
      }
      return message
    }
    toObject() {
      const data: {
        conf_id?: string
        question_content?: string
      } = {}
      if (this.conf_id != null) {
        data.conf_id = this.conf_id
      }
      if (this.question_content != null) {
        data.question_content = this.question_content
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.conf_id.length) writer.writeString(1, this.conf_id)
      if (this.question_content.length) writer.writeString(2, this.question_content)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): ActDetailResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new ActDetailResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.conf_id = reader.readString()
            break
          case 2:
            message.question_content = reader.readString()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): ActDetailResp {
      return ActDetailResp.deserialize(bytes)
    }
  }

  /**
      / 提交问卷
       /api/v1/proxy/10026/3/
       **/
  export class SubmitSurveyReq extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            timestamp?: number
            conf_id?: string
            question_content?: string
            take_time?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('timestamp' in data && data.timestamp != undefined) {
          this.timestamp = data.timestamp
        }
        if ('conf_id' in data && data.conf_id != undefined) {
          this.conf_id = data.conf_id
        }
        if ('question_content' in data && data.question_content != undefined) {
          this.question_content = data.question_content
        }
        if ('take_time' in data && data.take_time != undefined) {
          this.take_time = data.take_time
        }
      }
    }
    get timestamp() {
      return pb_1.Message.getFieldWithDefault(this, 1, 0) as number
    }
    set timestamp(value: number) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          问卷配置ID
           **/
    get conf_id() {
      return pb_1.Message.getFieldWithDefault(this, 2, '') as string
    }

    /**
          问卷配置ID
           **/
    set conf_id(value: string) {
      pb_1.Message.setField(this, 2, value)
    }

    /**
          问卷类容
           **/
    get question_content() {
      return pb_1.Message.getFieldWithDefault(this, 3, '') as string
    }

    /**
          问卷类容
           **/
    set question_content(value: string) {
      pb_1.Message.setField(this, 3, value)
    }

    /**
          填写问卷花费的时间, 毫秒
           **/
    get take_time() {
      return pb_1.Message.getFieldWithDefault(this, 4, 0) as number
    }

    /**
          填写问卷花费的时间, 毫秒
           **/
    set take_time(value: number) {
      pb_1.Message.setField(this, 4, value)
    }
    static fromObject(data: {
      timestamp?: number
      conf_id?: string
      question_content?: string
      take_time?: number
    }): SubmitSurveyReq {
      const message = new SubmitSurveyReq({})
      if (data.timestamp != null) {
        message.timestamp = data.timestamp
      }
      if (data.conf_id != null) {
        message.conf_id = data.conf_id
      }
      if (data.question_content != null) {
        message.question_content = data.question_content
      }
      if (data.take_time != null) {
        message.take_time = data.take_time
      }
      return message
    }
    toObject() {
      const data: {
        timestamp?: number
        conf_id?: string
        question_content?: string
        take_time?: number
      } = {}
      if (this.timestamp != null) {
        data.timestamp = this.timestamp
      }
      if (this.conf_id != null) {
        data.conf_id = this.conf_id
      }
      if (this.question_content != null) {
        data.question_content = this.question_content
      }
      if (this.take_time != null) {
        data.take_time = this.take_time
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.timestamp != 0) writer.writeInt64(1, this.timestamp)
      if (this.conf_id.length) writer.writeString(2, this.conf_id)
      if (this.question_content.length) writer.writeString(3, this.question_content)
      if (this.take_time != 0) writer.writeInt64(4, this.take_time)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubmitSurveyReq {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SubmitSurveyReq()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.timestamp = reader.readInt64()
            break
          case 2:
            message.conf_id = reader.readString()
            break
          case 3:
            message.question_content = reader.readString()
            break
          case 4:
            message.take_time = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SubmitSurveyReq {
      return SubmitSurveyReq.deserialize(bytes)
    }
  }
  export class SubmitSurveyResp extends pb_1.Message {
    #one_of_decls: number[][] = []
    constructor(
      data?:
        | any[]
        | {
            award_type?: AwardType
            award_amount?: number
          }
    ) {
      super()
      pb_1.Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], this.#one_of_decls)
      if (!Array.isArray(data) && typeof data == 'object') {
        if ('award_type' in data && data.award_type != undefined) {
          this.award_type = data.award_type
        }
        if ('award_amount' in data && data.award_amount != undefined) {
          this.award_amount = data.award_amount
        }
      }
    }

    /**
          奖励类型
           **/
    get award_type() {
      return pb_1.Message.getFieldWithDefault(this, 1, AwardType.Gold) as AwardType
    }

    /**
          奖励类型
           **/
    set award_type(value: AwardType) {
      pb_1.Message.setField(this, 1, value)
    }

    /**
          获取的奖励金额
           **/
    get award_amount() {
      return pb_1.Message.getFieldWithDefault(this, 6, 0) as number
    }

    /**
          获取的奖励金额
           **/
    set award_amount(value: number) {
      pb_1.Message.setField(this, 6, value)
    }
    static fromObject(data: { award_type?: AwardType; award_amount?: number }): SubmitSurveyResp {
      const message = new SubmitSurveyResp({})
      if (data.award_type != null) {
        message.award_type = data.award_type
      }
      if (data.award_amount != null) {
        message.award_amount = data.award_amount
      }
      return message
    }
    toObject() {
      const data: {
        award_type?: AwardType
        award_amount?: number
      } = {}
      if (this.award_type != null) {
        data.award_type = this.award_type
      }
      if (this.award_amount != null) {
        data.award_amount = this.award_amount
      }
      return data
    }
    serialize(): Uint8Array
    serialize(w: pb_1.BinaryWriter): void
    serialize(w?: pb_1.BinaryWriter): Uint8Array | void {
      const writer = w || new pb_1.BinaryWriter()
      if (this.award_type != AwardType.Gold) writer.writeEnum(1, this.award_type)
      if (this.award_amount != 0) writer.writeInt64(6, this.award_amount)
      if (!w) return writer.getResultBuffer()
    }
    static deserialize(bytes: Uint8Array | pb_1.BinaryReader): SubmitSurveyResp {
      const reader = bytes instanceof pb_1.BinaryReader ? bytes : new pb_1.BinaryReader(bytes),
        message = new SubmitSurveyResp()
      while (reader.nextField()) {
        if (reader.isEndGroup()) break
        switch (reader.getFieldNumber()) {
          case 1:
            message.award_type = reader.readEnum()
            break
          case 6:
            message.award_amount = reader.readInt64()
            break
          default:
            reader.skipField()
        }
      }
      return message
    }
    serializeBinary(): Uint8Array {
      return this.serialize()
    }
    static deserializeBinary(bytes: Uint8Array): SubmitSurveyResp {
      return SubmitSurveyResp.deserialize(bytes)
    }
  }
}
